export const ENUM = {
	roles:{
		COMPANY_DRIVER: 1,
		COMPANY_ADMIN: 2,
		CASHIER: 3,
		FINANCIAL: 4,
		SUPERVISOR: 5,
		ADMIN: 6,
		AIRPORT: 7,
		OPERATION: 8,
	},
	payment_method:{
		cash_payment:"CASH_PAYMENT",
		company_payment:"COMPANY_BALANCE_PAYMENT",
		driver_balance_payment:"DRIVER_BALANCE_PAYMENT"
	}
}
